import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";
import { useCallback, useEffect, useState } from "react";

import { type SessionPinOverride } from "../utils/applyActiveSessionPin";

/**
 * Session-only pin reposition for the currently selected comment. Cleared when
 * the user selects a different comment or leaves the view (unmount / refresh).
 */
export function useSessionPinOverride(activeCommentId: string | null) {
  const [sessionPinOverride, setSessionPinOverride] =
    useState<SessionPinOverride | null>(null);

  useEffect(() => {
    setSessionPinOverride((prev) =>
      prev != null && prev.commentId !== activeCommentId ? null : prev,
    );
  }, [activeCommentId]);

  const handlePinDragEnd = useCallback(
    (comment: BaseTicketComment, newRelX: number, newRelY: number) => {
      if (!comment._id) return;
      setSessionPinOverride({
        commentId: comment._id,
        relX: newRelX,
        relY: newRelY,
      });
    },
    [],
  );

  return { sessionPinOverride, handlePinDragEnd };
}
